import { useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton } from '@mui/material';
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Helpers from '../Helpers';

const styles = {
    card: {
        width: 380,
        display: 'flex',
        justifyContent: 'space-between',
    },
    info:{
        width: 324,
    },
    footer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    box:{
        display: 'flex',
        justifyContent: 'space-between',
    },
    data: {
        fontWeight: 'bold',
        fontSize: 13,
    },
    valor:{
        fontWeight: 'bold',
        fontSize: 13,
    },
};

function CardPedido({ item, filtroPedidos }){
    const navigate = useNavigate();
    const [pedido, setPedido] = useState(item);

    const detalhesPedido = (item) => {
        navigate('/pedidos/detalhe', { state: { pedido: item, filtroPedidos: filtroPedidos } });
    };

    return (
        <Card sx={styles.card} onClick={()=>detalhesPedido(pedido)}>
            <CardContent sx={styles.info}>
                <Box sx={styles.box}>
                    <Typography sx={styles.data}>{pedido.dt_venda} {pedido.hr_venda}</Typography>
                    <Typography sx={styles.valor}>{`R$ ${Helpers.formataValorPtBr(pedido.vr_total)}`}</Typography>
                </Box>

                <Typography sx={{ fontSize: 12 }}>{pedido.nm_cliente}</Typography>
                <Typography sx={{ fontSize: 10 }}>Vendedor: {pedido.nm_vendedor}</Typography>
                <Typography sx={{ fontSize: 10 }}>Cd venda: {pedido.cd_venda}</Typography>
                <Typography sx={{ fontSize: 10 }}>Id venda: {pedido.id}</Typography>
            </CardContent>

            <CardContent sx={styles.footer}>
                <IconButton  >
                    <ArrowForwardIosIcon />
                </IconButton>
            </CardContent>
        </Card>
    );
}

export default CardPedido;